'use client';

import type { FC, ReactNode } from 'react';
import { cn } from '../../../utils/cn';

interface ButtonGroupProps {
  children: ReactNode;
  className?: string;
  direction?: 'vertical' | 'horizontal';
}

export const ButtonGroup: FC<ButtonGroupProps> = ({ children, className, direction = 'vertical' }) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 w-full px-4 box-border',
        {
          'flex-row': direction === 'horizontal',
        },
        className
      )}
    >
      {children}
    </div>
  );
};
